<div class="loading-spinner text-primary">
  <figure class="text-center">
    <fstr-icon class="icon--rotating" anchor="icon-loading"></fstr-icon>
    <figcaption class="fs-body-xxxs d-block mt-2" *ngIf="text">
      {{ text }}
    </figcaption>
  </figure>
</div>
